'use client'

import { useEffect, useState } from 'react'
import { fetchGemPrices } from '../lib/gem-prices'

/** The backend's gem pack prices for this account (src/lib/gem-prices.js), or null until they arrive or when they
 *  cannot be had. Signed in, the account's own prices (half price on a paid plan, its set in the price test). */
export default function useGemPrices(user, authResolved) {
  const [answer, setAnswer] = useState(null)
  useEffect(() => {
    if (!authResolved) return
    let live = true
    ;(async () => {
      const token = user ? await user.getIdToken() : null
      const prices = await fetchGemPrices(token)
      if (live) setAnswer(prices)
    })()
    return () => {
      live = false
    }
  }, [user, authResolved])
  return answer
}
